module.exports = __webpack_public_path__ + "img/First-Institute-logo.07e194f6.png";